/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

var shippingAddressUpdate = require('./shippingAddressUpdate');
var $shipping = $('.shipping-content');

/* eslint-disable sonarjs/cognitive-complexity */
var selectStoreToShip = function (storeData) {
    var country = '';
    var countrySelector = $('#shippingCountry');
    if (countrySelector && countrySelector.length > 0) {
        country = countrySelector.val();
    }

    if (storeData.bossStoreName) {
        $shipping.find('.shippingAddressOne').val(storeData.bossStoreName.substring(0, 30));

        if (storeData.bossStoreAddress1) {
            $shipping.find('.shippingAddressTwo').val(storeData.bossStoreAddress1.substring(0, 30) + ' ' + storeData.bossStoreAddress2);
        } else {
            $shipping.find('.shippingAddressTwo').val('');
        }
    } else if (storeData.bossStoreAddress1) {
        $shipping.find('.shippingAddressOne').val(storeData.bossStoreAddress1.substring(0, 30));
        $shipping.find('.shippingAddressTwo').val('');
    }

    if (storeData.bossStoreCity) {
        $shipping.find('.shippingAddressCity').val(storeData.bossStoreCity).trigger('change');
    }

    if (storeData.bossStoreRegion) {
        var stateSelector = $shipping.find('#shippingState');
        if (stateSelector && stateSelector.length > 0) {
            // Handle Malaysia-specific logic as State drop down uses short codes
            if (country === 'MY') {
                var $matchingOption = stateSelector.find('option').filter(function () {
                    return $(this).text() === storeData.bossStoreRegion;
                });

                if ($matchingOption.length > 0) {
                    stateSelector.val($matchingOption.val()).trigger('change');
                }
            } else {
                // Default behavior for non-MY countries
                stateSelector.val(storeData.bossStoreRegion).trigger('change');
            }
        }
    }

    if (storeData.bossStorePostal) {
        $shipping.find('.shippingZipCode').val(storeData.bossStorePostal).trigger('change');
    }

    // City information updated in checkout.js handleShippingDynamicDropdowns

    $('.boss-store-id').val(storeData.bossStoreId);

    var $shippingForm = $('.shipping-form');
    var shippingHelpers = require('./shipping');
    shippingHelpers.methods.updateShippingMethodList($shippingForm);
};

var addEventListeners = function () {
    $(document).on('click', '.boss-store', function () {
        var storeData = $(this).data();
        if (!$(this).hasClass('store-selected')) {
            $('.boss-store.store-selected').find('input').prop('checked', null).parents('.boss-store')
                .removeClass('store-selected');
            $(this).addClass('store-selected').find('input').prop('checked', true);
            $('#bossShipToStoreError').hide();
            selectStoreToShip(storeData);
        }
    });
};

var displayShippingMethod = function () {
    var $shippingTypeRegular = $('.shipping-type-regular');
    var $shippingTypeBoss = $('.shipping-type-boss');
    $shippingTypeRegular.find('input[data-shippingtype="boss"]').parent().remove();
    $shippingTypeBoss.find('input[data-shippingtype="regular"]').parent().remove();
    $shippingTypeBoss.find('input[data-shippingtype="access-point"]').parent().remove();
};

module.exports = {

    methods: {
        displayShippingMethod: displayShippingMethod
    },
    addEventListeners: addEventListeners,

    initBoss: function () {
        shippingAddressUpdate.isShippingRegular();
        shippingAddressUpdate.addEventListeners();
        addEventListeners();
        $shipping.on('click', '#shipping-type-selector-boss', function (e) {
            e.stopImmediatePropagation();
            shippingAddressUpdate.clearForm();
            shippingAddressUpdate.selectShippingType('boss');
        });
    }
};
